import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Button, DataDisplayPlain, Title } from '@e2n/ui/v2';
import { faEnvelope, faPen, faPhone } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Kontakt() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();

  const data = form.state.values;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2 items-center justify-between">
        <Title className="wrap-break-word">
          {t('domain.mitarbeiter.create.steps.person.kontakt.title')}
        </Title>
        <Button
          iconOnly
          variant={'secondary-red-on-grey'}
          className="bg-neutrals-v2-100"
          onClick={() => ctx.navigateToSubStep('person.kontakt')}>
          <FontAwesomeIcon icon={faPen} />
        </Button>
      </div>
      <div className="flex flex-col gap-3">
        <DataDisplayPlain
          variant="text"
          orientation="horizontal"
          label={<FontAwesomeIcon icon={faEnvelope} />}
          item={data.person.kontakt.email || '-'}
        />
        <DataDisplayPlain
          variant="text"
          orientation="horizontal"
          label={<FontAwesomeIcon icon={faPhone} />}
          item={data.person.kontakt.mobilnummer || '-'}
        />
      </div>
    </div>
  );
}
